export default __webpack_public_path__ + "static/blog-img8-e7042fa6ba4a9612cf237f20ea905a26.jpg";